import React from 'react';
import { Card, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CountrySelectorLabel } from '../../nacre/components/countrySelector';
import { PhoneLabel } from '../../components/phone/phone';
import './organizerProfile.scss';

export default function GeneralInformation({ formOrganisation, onChange, organization, organisationErrors }) {
    const { t } = useTranslation();

    return (
        <Card.FormStep className="organizer-formstep-form" title={t(`ticket.organiser.general_information.title`)} rightComponent id="organiser-form-general_information">
            <>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.address')} required />
                    <Form.Input
                        errors={!!organisationErrors['address']?.['address1']}
                        maxLength={80}
                        name="address1"
                        value={formOrganisation.address.address1}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, address1: value });
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['address']?.['address1'] ? [t(organisationErrors['address']?.['address1'])] : null} />
                </Form.Field>
                {(formOrganisation?.address?.country === 'CA' || formOrganisation?.address?.country === 'US') && (
                    <Form.Field>
                        <Form.Label label={t('ticket.event.state')} required />
                        <Form.Input
                            errors={!!organisationErrors['address']?.['state']}
                            maxLength={80}
                            name="state"
                            value={formOrganisation.address.state}
                            onChange={({ target: { value } }) => {
                                onChange('address', { ...formOrganisation.address, state: value });
                            }}
                        />
                        <Form.FieldErrors errors={organisationErrors['address']?.['state'] ? [t(organisationErrors['address']?.['state'])] : null} />
                    </Form.Field>
                )}
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.zip_code')} required />
                    <Form.Input
                        errors={!!organisationErrors['address']?.['zip_code']}
                        maxLength={80}
                        name="zip_code"
                        value={formOrganisation.address.zip_code}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, zip_code: value });
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['address']?.['zip_code'] ? [t(organisationErrors['address']?.['zip_code'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.city')} required />
                    <Form.Input
                        errors={!!organisationErrors['address']?.['city']}
                        maxLength={80}
                        name="city"
                        value={formOrganisation.address.city}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, city: value });
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['address']?.['city'] ? [t(organisationErrors['address']?.['city'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.country')} required />
                    <CountrySelectorLabel
                        errors={!!organisationErrors['address']?.['country']}
                        placeholder={t('ticket.event.country_placeholder')}
                        value={formOrganisation.address.country}
                        onChange={value => {
                            onChange('address', { ...formOrganisation.address, country: value });
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['address']?.['country'] ? [t(organisationErrors['address']?.['country'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.phone')} required />
                    <PhoneLabel
                        errors={!!organisationErrors['phone_number']}
                        debounceTimeout={700}
                        value={formOrganisation.phone_number}
                        onChange={value => {
                            onChange('phone_number', value);
                        }}
                    />
                    <Form.FieldErrors errors={organisationErrors['phone_number'] ? [t(organisationErrors['phone_number'])] : null} />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.website')} />
                    <Form.Input
                        errors={!!organisationErrors['website']}
                        maxLength={80}
                        name="website"
                        value={formOrganisation.website}
                        onChange={({ target: { value } }) => {
                            onChange('website', value);
                        }}
                    />
                </Form.Field>
                {formOrganisation?.website?.startsWith('http:') && <label className="organizer-form-website-message">{t('ticket.common.validator_website_http')}</label>}
                <Form.FieldErrors errors={[t(organisationErrors['website'])]} />
            </>
        </Card.FormStep>
    );
}
GeneralInformation.propTypes = {
    organization: PropTypes.object.isRequired,
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    organisationErrors: PropTypes.object.isRequired
};
